export enum AreaSearchTypes {
    all = 0,
    norway = 1,
    reindeer = 2,
}
